<template>
	<div>
		<template v-for="(content, i) in componentItem.content">
			<div :key="i">
				<div v-if="typeof content !== 'object'">
					<div class="form-group">
						<label>{{ i }}</label>
						<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
					</div>
					<hr>
				</div>
				<div v-else>
					<div v-for="(item, i) in content" v-bind:key="i">
						<div v-bind:key="i">
							<div v-for="(property, j) in item" v-bind:key="j">
								<div v-bind:key="j">
									<div class="form-group">
										<label>{{ j }}</label>
										<textarea v-if="j == 'description'" rows="5" class="form-control" :id="`${i}image-and-body-copy${index}`" v-model="item[j]"></textarea>
										<ImageUploader v-else-if="j == 'thumbnail-image'" :size="'more-content-unit'" :forTemplate="componentItem.template" :imageFieldKey="j" :imageFieldObject="item" ></ImageUploader>
										<input v-else type="text" class="form-control" :id="j" v-model="item[j]" >
									</div>
								</div>
							</div>
							<hr>
						</div> 
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>

	import VueFroala from 'vue-froala-wysiwyg'
	import 'froala-editor/css/froala_editor.pkgd.min.css';
	import 'froala-editor/js/plugins/link.min.js';
	import Vue from 'vue';
	import ImageUploader from '../ImageUploader.vue'
	Vue.use(VueFroala);

	export default {
		
		name: 'MoreContentUnit',

		components: {
			ImageUploader
		},		

		props: ['componentItem', 'index'],

		data () {
			return {
				config: {
					events: {
						initialized: function () {

						}
					},
					toolbarButtons: [['bold', 'italic', 'subscript', 'superscript', 'insertLink'], ['undo', 'redo']],
					attribution: false,
					key: 'Ig1A7vC2B1D2E1E1D4mvB16C-21B7D-13csmwtpkpE4cmmvj1cthfD-11G5eiyrA1C7A6F6E1D4F4E1C10D6==',
				},
			}
		}

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>